import { getFullUrl } from "../config";
import {
  CreateOfflineLabtestOrderPayload,
  OfflineLabtestListingParams,
  OfflineLabtestListingResponse,
  OfflineLabtestOrderDetails,
} from "./types";

export class OfflineLabtestService {
  private static getToken(): string | null {
    return localStorage.getItem("token");
  }

  // 1. Create Offline Labtest Order
  static async createOrder(payload: CreateOfflineLabtestOrderPayload) {
    const response = await fetch(getFullUrl("/orderservice/offline-labtest/create"), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${this.getToken()}`,
      },
      body: JSON.stringify(payload),
    });
    return response.json();
  }

  // 2. Listing
  static async getListing(params: OfflineLabtestListingParams): Promise<OfflineLabtestListingResponse> {
    const queryParams = new URLSearchParams();
    if (params.page) queryParams.append("page", params.page.toString());
    if (params.pageSize) queryParams.append("pageSize", params.pageSize.toString());
    if (params.clinicId) queryParams.append("clinicId", params.clinicId);
    if (params.patientMobileNumber) queryParams.append("patientMobileNumber", params.patientMobileNumber);
    if (params.invoiceNumber) queryParams.append("invoiceNumber", params.invoiceNumber);
    if (params.status) queryParams.append("status", params.status);

    const url = `${getFullUrl("/orderservice/offline-labtest/listing")}?${queryParams.toString()}`;
    const response = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${this.getToken()}`,
      },
    });
    return response.json();
  }

  // 3. Cancel Order
  static async cancelOrder(orderId: number) {
    const response = await fetch(getFullUrl(`/orderservice/offline-labtest/cancel/${orderId}`), {
      method: "PUT",
      headers: {
        Authorization: `Bearer ${this.getToken()}`,
      },
    });
    return response.json();
  }

  // 4. Collect Sample
  static async collectSample(orderId: number, collectedSampleCode: string) {
    const response = await fetch(getFullUrl("/orderservice/offline-labtest/collect-sample"), {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${this.getToken()}`,
      },
      body: JSON.stringify({ orderId, collectedSampleCode }),
    });
    return response.json();
  }

  // 5. Upload Report
  static async uploadReport(orderId: number, orderLabtestId: number, files: File | File[]) {
    const formData = new FormData();
    formData.append("orderLabtestId", orderLabtestId.toString());
    if (Array.isArray(files)) {
      files.forEach((file) => formData.append("image", file));
    } else {
      formData.append("image", files);
    }

    const response = await fetch(getFullUrl(`/orderservice/offline-labtest/upload-report/${orderId}`), {
      method: "PUT",
      headers: {
        Authorization: `Bearer ${this.getToken()}`,
      },
      body: formData,
    });
    return response.json();
  }

  // 6. Get Complete Details
  static async getDetails(orderId: number): Promise<{ success: boolean; message: string; data: OfflineLabtestOrderDetails }> {
    const response = await fetch(getFullUrl(`/orderservice/offline-labtest/details/${orderId}`), {
      method: "GET",
      headers: {
        Authorization: `Bearer ${this.getToken()}`,
      },
    });
    return response.json();
  }
}
